<template>
  <div>
    <div class="emotion-box" :style="{height: height + 'px' }" >
      <van-swipe :autoplay="0" :loop="false" :style="{height: height + 'px' }">
        <van-swipe-item v-for="(swipe, index) in list" :key="index">
          <div class="emotion-box-line" v-for="(line, i) in swipe.item" :key="i" >
            <emotion class="emotion-item" v-for="(item, i) in line" :key="i" @click.native="clickHandler(item)" >{{item}}</emotion>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<script>
import Emotion from './Emotion'
export default {
  props: {
    height: {
      type: Number,
      default: 138,
    }
  },
  data () {
    return {
      list: [{
          item: [
            ['微笑', '撇嘴', '色', '发呆', '得意', '流泪', '害羞', '闭嘴'],
            ['睡', '大哭', '尴尬', '发怒', '调皮', '呲牙', '惊讶', '难过'],
            ['酷', '冷汗', '抓狂', '吐', '偷笑', '可爱', '白眼', '傲慢'],
          ]
        },
        {
          item: [
            ['饥饿', '困', '惊恐', '流汗', '憨笑', '大兵', '奋斗', '咒骂'],
            ['疑问', '嘘', '晕', '折磨', '衰', '骷髅', '敲打', '再见'],
            ['擦汗', '抠鼻', '鼓掌', '糗大了', '坏笑', '左哼哼', '右哼哼', '哈欠'],
          ]
        },
        {
          item: [
            ['鄙视', '委屈', '快哭了', '阴险', '亲亲', '吓', '可怜', '菜刀'],
            ['西瓜', '啤酒', '篮球', '乒乓', '咖啡', '饭', '猪头', '玫瑰', ],
            ['凋谢', '示爱', '爱心', '心碎', '蛋糕', '闪电', '炸弹', '刀'],
          ]
        },
        {
          item: [
            ['足球', '瓢虫', '便便', '月亮', '太阳', '礼物', '拥抱', '强'],
            ['弱', '握手', '胜利', '抱拳', '勾引', '拳头', '差劲', '爱你'],
            ['NO', 'OK', '爱情', '飞吻', '跳跳', '发抖', '怄火', '转圈'],
          ]
        },
        {
          item: [
            ['磕头', '回头', '跳绳', '挥手', '激动', '街舞', '左太极', '右太极'],
          ]
        },
      ]
    }
  },
  methods: {
    clickHandler (i) {
      let emotion = `#${i};`
      this.$emit('emotion', emotion)
    },
    
  },
  components: {
    Emotion
  }
}
</script>
<style scoped>
  .emotion-box {
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
    padding: 5px;/*no*/
    border: 1px solid #eee; /*no*/
    overflow: hidden;
  }
  .emotion-box-line {
    display: flex;
    height: 38px;/*no*/
    line-height: 38px;/*no*/
  }
  .emotion-item {
    flex: 1;
    text-align: center;
    cursor: pointer;
    height: 38px;/*no*/
    line-height: 38px;/*no*/
  }

</style>
<style>
.emotion-box .van-swipe{
  padding-bottom: 0;/*no*/
  box-sizing: border-box;
}
.emotion-box .van-swipe__indicators{
  bottom: 20px;/*no*/
}
.emotion-box .van-swipe__indicator{
  background-color: rgba(0,0,0,.5);
}
</style>